import { Theme } from '@emotion/react';
import { tabsBase, tabsContainer } from './tabsCssDefs';
import React from 'react';

export type TabListProps = {
  /**
   * Required value, string set to ensure there is a aria label present
   */
  'aria-label': string;
  /**
   * Optional fullWidth, boolean to set the children components to fill their container
   */
  fullWidth?: boolean;
  /**
   * Optional centered, boolean to set the positioning of the tabs to center
   */
  centered?: boolean;
  /**
   * Optional contained, boolean to set a border bottom to the full width tab container
   */
  contained?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

/**
 * @deprecated Deprecated — use pantry Tabs instead.
 * @see https://docs.tocktix.com/pantry?path=/docs/components-tabs--docs
 * Migration: Replace TabList with the corresponding sub-component in pantry Tabs.
 */
export const TabList = ({
  children,
  fullWidth,
  contained,
  centered,
  'aria-label': ariaLabel,
  ...rest
}: TabListProps) => {
  return (
    <div css={(theme: Theme) => tabsContainer(theme, contained, centered)} {...rest}>
      <div
        css={(theme: Theme) => tabsBase(theme, fullWidth)}
        role="tablist"
        tabIndex={0}
        aria-label={ariaLabel}
      >
        {children}
      </div>
    </div>
  );
};
